export default __webpack_public_path__ + "static/media/partnershipIcon3.b5e65d3a.png";